import { updateProject } from 'common/api/v1/projects';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import fetchProject from '../../project/actions/fetchProject';
import {
    SAVE_PROJECT,
    SAVE_PROJECT_SUCCESS,
    SAVE_PROJECT_FAILURE,
} from '../actionTypes';
import { loadAndWindModalActons } from '../reducer';

import openModal from './openModal';

export default (values) => (dispatch) => {
    dispatch(loadAndWindModalActons[SAVE_PROJECT]());

    updateProject(values, values.id)
        .then((response) => {
            dispatch(
                loadAndWindModalActons[SAVE_PROJECT_SUCCESS](response.data),
            );
            dispatch(openModal(false));
            if (values?.id) dispatch(fetchProject(values.id));
            showToast();
        })
        .catch((error) => {
            dispatch(
                loadAndWindModalActons[SAVE_PROJECT_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
